
export const API_PATH = {
    BASE_PATH: 'https://5wyr8dfzf9.execute-api.eu-west-1.amazonaws.com/prod/',
    RECOMMENDATION: '/recommendations',
    FILTERING: '/filtering',
    COURSE_SUBMISSION: 'submissions'
}